import kzLoginImg from '@/assets/images/kz-logo.png';
import bannerHomeImg from '@/assets/images/wx/banner/home.png';
import bannerMassImg from '@/assets/images/wx/banner/mass.png';
import bannerQrcodeImg from '@/assets/images/wx/banner/qrcode.png';
import bannerPosterImg from '@/assets/images/wx/banner/poster.png';
import bannerMenuImg from '@/assets/images/wx/banner/menu.png';
import bannerAutoReply from '@/assets/images/wx/banner/auto-reply.png';

// 图片静态资源导出
export {
  kzLoginImg,
  bannerHomeImg,
  bannerMassImg,
  bannerQrcodeImg,
  bannerPosterImg,
  bannerMenuImg,
  bannerAutoReply,
}

export const URL_LOGIN_WAP = `//www.kuaizhan.com/v2/passport/login?callback=https://www.kuaizhan.com/weixin`
export const URL_LOGIN_PC = '/passport/login?refer=/v3/weixin/list'

export const URL_REGISTER_WAP = '//www.kuaizhan.com/v2/passport/reg'
export const URL_REGISTER_PC = '//www.kuaizhan.com/passport/'

export const URL_LOGOUT_WAP = '//www.kuaizhan.com/v2/passport/logout'
export const URL_LOGOUT_PC = '//www.kuaizhan.com/passport/logout'

export const URL_KUAIZHAN = '//www.kuaizhan.com'
export const URL_KUAIMA = '//kuaima.kuaizhan.com'
export const URL_CHANGYAN = '//changyan.kuaizhan.com/'

export { FOOTER_CONTENT } from './kzHomepage'


export const SEO = {
  home: {
    keyword: '快站，公众号，快站公众号，微信公众号，公众号裂变，公众号运营，公众号推广，公众号涨粉，公众号管理，外卖 ，群发  微信群发  客服群发  模板群发  渠道二维码  裂变海报，自动回复，被关注自动回复，关键词自动回复，消息自动回复，微积粉，自定义菜单，个性化菜单，微信客服，公众号红包',
    description: '快站公众号是一款公众号管理、营销的运营工具，可以帮助运营者们设置美化自己的公众号，同时为运营者准备了一系列的如裂变海报拉新获取积分，积分兑换礼物或红包等的积分体系，关键词自动回复，互动文字、跳转文字增加趣味性工具，微信群发以及客服群发等功能进行促活手段等营销裂变解决方案。',
  },
  poster: {
    keyword: '快站，公众号，快站公众号，微信公众号，公众号裂变，公众号营销，裂变海报，微积粉，公众号积分，公众号兑换礼品，公众号兑换红包，公众号拉新，公众号留存，分级裂变，区域推广',
    description: '快站公众号裂变海报是快站为公众号运营者打造的积分体系中最重要的一环-拉新。粉丝通过分享裂变海报，好友扫码双方同时获取积分，积分可兑换礼品或红包，增强粉丝活动黏性，无限拉新关注公众号。支持设置活动范围，根据Gps定位获取用户实时位置判断是否有参与活动资格，支持自定义活动文案，增强趣味性。',
  },
  'qr-code': {
    keyword: '快站，公众号，快站公众号，渠道二维码，微信公众号，公众号裂变，公众号运营，公众号推广，渠道推广，扫码打标签，扫码发送消息，扫码数据统计，渠道数据，扫码打标签，扫码发送消息',
    description: '快站公众号渠道二维码可帮助运营者分渠道推广公众号，并详细的统计到各个渠道不同的数据择优着重推广。快站渠道二维码支持扫码自动打标签以及扫码自动发送消息，消息支持多条消息发送并支持多种消息类型：图文消息、链接组、文本、粉丝昵称、表情、当前日期、互动文字、跳转文字、图片和小程序等',
  },
  mass: {
    keyword: '快站，公众号，快站公众号，微信公众号，公众号促活，微信群发，客服群发，模板群发，定时群发，延时群发，筛选群发，循环群发，多类型内容发送，多条消息群发，随机发送，无限群发，突破限制群发',
    description: '快站公众号群发功能共有三大模块，微信群发、客服群发、模板群发，微信群发可触达所有的用户群发消息，客服群发可突破限制不限量群发，并支持设置循环发送，每日固定时间快站帮您群发消息，支持插入图文消息、链接组、文本、粉丝昵称、表情、当前日期、互动文字、跳转文字、图片和小程序等，模板群发同样可触达所有用户，并支持改变字体颜色以及插入粉丝昵称',
  },
  menu: {
    keyword: '快站，公众号，快站公众号，微信公众号，公众号运营，公众号推广，公众号管理，公众号菜单，自定义菜单，个性化菜单，公众号菜单设置，菜单名称突破限制，菜单表情',
    description: '快站公众号自定义菜单模块支持微信官方的一切设置，除此以外，突破单个菜单的字数限制展示给粉丝更多的信息，菜单支持添加表情，更加趣味性增加粉丝黏性，支持点击菜单跳转链接、跳转小程序，发送图文消息、链接组、文本、粉丝昵称、表情、当前日期、互动文字、跳转文字、图片和小程序等。支持设置个性化菜单，根据多维度筛选条件不同粉丝看到不同的菜单，渠道活动更加得心应手。',
  },
  'auto-reply': {
    keyword: '快站，公众号，快站公众号，微信公众号，公众号运营，公众号促活，公众号管理，自动回复，被关注自动回复，关键词自动回复，消息自动回复，延时回复，自动回复打标签，多条消息自动回复，关键词自动打标签，关键词',
    description: '快站公众号自动回复可促活增强用户黏性。共三部分：被关注自动回复，粉丝关注后自动发送信息，告达用户公众号的功能，以及常见问题解释等；关键词自动回复，粉丝发送消息后完全匹配/模糊匹配某关键词自动回复对应消息，制作自己的回复机器人；消息自动回复，除以上两种类型的回复，都归为消息自动回复，保证所有的粉丝发送消息必有回复，增强用户黏性。'
  }
}
